

export default {
  name: "Contact",
  data: function () {
    return {
        name: "",
        email: "",
        phone:"",
        message: "",
        is_alert: false,
        is_submit: false,
        alert_message: "",
        alert_style: 'alert-danger',
    };
  },

  methods: {
    async sendMessage(){
        this.is_submit = true;
        if(this.name === "" || this.email === "" || this.phone === "" || this.message === ""){
            this.is_alert = true;
            this.alert_message = "Please fill out all fields";
            this.alert_style = 'alert-danger';
            setTimeout(() => {
                this.is_alert = false;
                this.alert_message = "";
            }, 2000);
            this.is_submit = false;
           
        } else {
            const now = new Date();

            const formData = {
                name: this.name,
                email: this.email,
                phone: this.phone,
                message: this.message,
                date: now.toLocaleDateString(),
              };

              console.log(formData);

            try {
                // Send the data to SheetDB API
                const response = await fetch("https://sheetdb.io/api/v1/xdbnyle4kzgz3", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({ fields: formData }),
                });

                console.log(response);
        
                if (response.ok) {
                  
                  this.name = "";
                  this.email = "";
                  this.phone = "";
                  this.message = "";
                
                  this.alert_style = 'alert-success';
                  this.is_alert = true;
                  this.alert_message = "Message sent successfully.";
                  setTimeout(() => {
                      this.is_alert = false;
                      this.alert_message = "";
                  }, 2000);
                  this.is_submit = false;

                } else {
                  this.alert_style = 'alert-danger';
                  this.is_alert = true;
                  this.alert_message = "Failed to send message.";
                  setTimeout(() => {
                      this.is_alert = false;
                      this.alert_message = "";
                  }, 2000);
                  this.is_submit = false;
                  throw new Error("Failed to send message.");
                }
              } catch (error) {
                this.is_submit = false;
                this.is_alert = true;
                this.alert_message = error.message;
                this.alert_style = 'alert-danger';
                setTimeout(() => {
                    this.is_alert = false;
                    this.alert_message = "";
                }, 2000);
              } 
        }
    }
  }
};